import { render, staticRenderFns } from "./blank.vue?vue&type=template&id=4c9a7d41&scoped=true&"
import script from "./blank.vue?vue&type=script&lang=js&"
export * from "./blank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9a7d41",
  null
  
)

export default component.exports